import React, { useState, useEffect } from "react";
import "../Styles/style.css";
import axios from "axios";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { baseUrl } from "../../api/ipconfig";
import { useHistory, useLocation } from "react-router-dom";
import { Drawer, Button, Box } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Autocomplete,
  Chip,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"; // import Tick from "../../images/bike-searchTick.png";

export default function Sidebar({
  vehicleCategory,
  onFilterChange,
  selectedFilters,
}) {
  const location = useLocation();
  const histtory = useHistory();

  const queryParams = new URLSearchParams(location.search);

  const selectedAdType = queryParams.get("postType");
  const keywordSearch = queryParams.get("keyword");

  const selectedCategory = queryParams.get("ctg");
  const searhcedCategory = selectedCategory
    ? selectedCategory.split(",").map(String)
    : null;

  const selectedCity = queryParams.get("city");
  const searhcedCity = selectedCity ? selectedCity.split(",").map(String) : [];

  const selectedMake = queryParams.get("make");
  const searhcedMakes = selectedMake ? selectedMake.split(",").map(String) : [];

  const selectedModel = queryParams.get("model");
  const searhcedModel = selectedModel
    ? selectedModel.split(",").map(String)
    : [];

  const selectedYear = queryParams.get("year");

  const [allCities, setAllCities] = useState([]);

  const [allMake, setAllMake] = useState([]);
  const [allModel, setAllModel] = useState([]);
  const [SearchInput, setSearchInput] = useState("");
  const [selectedCategry, setSelectedCategry] = useState(searhcedCategory);
  const [selectedCities, setSelectedCities] = useState(searhcedCity);
  const [selectedMakes, setSelectedMakes] = useState(searhcedMakes);
  const [selectedModels, setSelectedModels] = useState(searhcedModel);
  const [selectedYears, setSelectedYears] = useState(searhcedModel);
  const [modelYear, setModelYear] = useState([]);
  const [more, setMore] = useState(11);
  const [moreColor, setMoreColor] = useState(11);
  const [openCity, setOpenCity] = useState(false);
  const [openMake, setOpenMake] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const [openYear, setOpenYear] = useState(false);
  const [featureAd, setFeatureAd] = useState(selectedAdType ? true : false);

  const [cities, setCities] = useState([]);

  const toggleDrawerCity = () => {
    setOpenCity(!openCity);
  };

  const toggleDrawerMake = () => {
    setOpenMake(!openMake);
  };

  const toggleDrawerModel = () => {
    setOpenModel(!openModel);
  };

  const toggleDrawerYear = () => {
    setOpenYear(!openYear);
  };

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axios.get(`${baseUrl}/cities`);
        setAllCities(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchFilters();
  }, []);

  useEffect(() => {
    const fetchMake = async () => {
      try {
        const response = await axios.get(`${baseUrl}/get-bike-makes`);
        setAllMake(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMake();
  }, []);

  useEffect(() => {
    if (keywordSearch) {
      setSearchInput(keywordSearch);
    }
    if (selectedMake && allMake) {
      const makeObject = allMake.find(
        (make) => make.bikemake_name === selectedMake
      );
      if (makeObject) {
        setSelectedMakeValue(makeObject);
      }
    }
  }, [allMake]);

  useEffect(() => {
    const fetchModel = async () => {
      try {
        const response = await axios.get(`${baseUrl}/bike-model-by-make-name`, {
          params: {
            make_name: selectedMakes,
          },
        });
        setAllModel(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (selectedMakes.length > 0) {
      fetchModel();
    }
  }, [selectedMakes]);

  useEffect(() => {
    const fetchYear = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getModelYear`);

        setModelYear(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchYear();
  }, [selectedModels]);

  useEffect(() => {
    const fetchCityData = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getPostsCountByCities`); // Replace with the actual API endpoint
        setCities(response.data);
      } catch (error) {
        console.error("Error fetching city data:", error);
      }
    };

    fetchCityData();
  }, []);

  const totalCount = cities.reduce((sum, city) => sum + city.postCount, 0);

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  const handleClearAllFilters = () => {
    setSelectedCities([]);
    onFilterChange("city", []);
    setSelectedMakes([]);
    onFilterChange("make", []);
    setSelectedModels([]);
    onFilterChange("Year", []);
    setSelectedYears([]);
    onFilterChange("year", []);
    onFilterChange("category", null);
    setSelectedCityValue(null);
    setSelectedMakeValue(null);
    setSelectedModelValue(null);
    setSelectedYearValue(null);
    setSelectedCategoryValue(null);
    setSelectedCategry(null);
    setSearchInput("");
    onFilterChange("search", []);
    histtory.replace(`/bike-search`);
  };

  const ClearMakeFilter = () => {
    setSelectedMakes([]);
    onFilterChange("make", []);
    setSelectedMakeValue(null);

    const params = new URLSearchParams(window.location.search);
    params.delete("make");

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    histtory.replace(`/bike-search?${newUrl}`);
  };

  const ClearModelFilter = () => {
    setSelectedModels([]);
    onFilterChange("model", []);
    setSelectedModelValue(null);

    const params = new URLSearchParams(window.location.search);
    params.delete("model");

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    histtory.replace(`/bike-search?${newUrl}`);
  };

  const ClearCityFilter = () => {
    setSelectedCities([]);
    onFilterChange("city", []);
    setSelectedCityValue(null);

    const params = new URLSearchParams(window.location.search);
    params.delete("city");

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    histtory.replace(`/bike-search?${newUrl}`);
  };

  const ClearYearFilter = () => {
    setSelectedYears([]);
    onFilterChange("year", []);
    setSelectedYearValue(null);

    const params = new URLSearchParams(window.location.search);
    params.delete("year");

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    histtory.replace(`/bike-search?${newUrl}`);
  };

  const [selectedCityValue, setSelectedCityValue] = useState(null);
  const [selectedMakeValue, setSelectedMakeValue] = useState(null);
  const [selectedModelValue, setSelectedModelValue] = useState(null);
  const [selectedYearValue, setSelectedYearValue] = useState(null);
  const [selectedCategoryValue, setSelectedCategoryValue] = useState(null);

  const handleCitySelect = (city) => {
    if (city) {
      // If a city is selected, update the state to contain only this city
      setSelectedCities([city]);
      onFilterChange("city", [city]);
    } else {
      // If no city is selected, clear the selection
      setSelectedCities([]);
      onFilterChange("city", []);
    }
  };

  const handleAutocompleteCityChange = (event, newValue) => {
    if (newValue) {
      handleCitySelect(newValue.cityName);
      setSelectedCityValue(newValue);
    } else {
      setSelectedCityValue(null);
    }
  };

  const handleMakeSelect = (make) => {
    if (make) {
      // If a city is selected, update the state to contain only this city
      setSelectedMakes([make]);
      onFilterChange("make", [make]);
    } else {
      // If no city is selected, clear the selection
      setSelectedMakes([]);
      onFilterChange("make", []);
    }
  };

  const handleAutocompleteMakeChange = (event, newValue) => {
    if (newValue) {
      handleMakeSelect(newValue?.bikemake_name);
      setSelectedMakeValue(newValue);
    } else {
      setSelectedMakeValue(null);
    }
  };

  const handleModelSelect = (model) => {
    if (model) {
      // If a city is selected, update the state to contain only this city
      setSelectedModels([model]);
      onFilterChange("model", [model]);
    } else {
      // If no city is selected, clear the selection
      setSelectedModels([]);
      onFilterChange("model", []);
    }
  };

  const handleAutocompleteModelChange = (event, newValue) => {
    if (newValue) {
      handleModelSelect(newValue.bikemodel_name);
      setSelectedModelValue(newValue);
    } else {
      setSelectedModelValue(null);
    }
  };

  const handleYearSelect = (year) => {
    if (year) {
      // If a city is selected, update the state to contain only this city
      setSelectedYears([year]);
      onFilterChange("year", [year]);
    } else {
      // If no city is selected, clear the selection
      setSelectedYears([]);
      onFilterChange("year", []);
    }
  };

  const handleAutocompleteYearChange = (event, newValue) => {
    if (newValue) {
      handleYearSelect(newValue.yearId);
      setSelectedYearValue(newValue);
    } else {
      setSelectedYearValue(null);
    }
  };

  const handleCategorySelect = (newValue) => {
    if (newValue) {
      const category = Number(newValue.category);
      setSelectedCategoryValue(newValue);
      setSelectedCategry(category);
      onFilterChange("category", category);
    } else {
      setSelectedCategoryValue(null);
      onFilterChange("category", null);
    }
  };

  const handleFeatureAdChange = () => {
    const updatedValue = !featureAd;
    setFeatureAd(updatedValue);
    onFilterChange("postType", updatedValue ? 2 : 0);
  };

  const handleMinPriceChange = (event) => {
    const minPrice = Number(event.target.value);
    if (minPrice <= selectedFilters.maxPrice) {
      onFilterChange("minPrice", minPrice);
    }
  };
  const handleSearchChange = (e) => {
    e.preventDefault();
    onFilterChange("search", SearchInput);
  };

  const handleMaxPriceChange = (event) => {
    const maxPrice = Number(event.target.value);
    if (maxPrice >= selectedFilters.minPrice) {
      onFilterChange("maxPrice", maxPrice);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams();

    if (selectedMakes?.length || selectedMake)
      params.append("make", selectedMakes || selectedMake);
    if (selectedModels?.length || selectedModel)
      params.append("model", selectedModels || selectedModel);
    if (selectedYearValue !== null || selectedYear)
      params.append("year", selectedYearValue?.year || selectedYear);
    if (selectedCities?.length || selectedCity)
      params.append("city", selectedCities || selectedCity);
    if (selectedCategry !== null)
      params.append("category", selectedCategry + "cc");
    if (SearchInput || keywordSearch)
      params.append("keyword", SearchInput || keywordSearch);
    if (featureAd) params.append("postType", featureAd == true && "featured");

    histtory.replace(`/bike-search?${params.toString()}`);
  }, [
    selectedMakes,
    selectedCities,
    selectedModels,
    selectedCategry,
    SearchInput,
    featureAd,
  ]);

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Adsbygoogle error: ", e);
      // alert(e);
    }
  }, []);

  const colorsData = [
    {
      name: "white",
      code: "#FFFFFF",
    },
    {
      name: "Silver",
      code: "#C0C0C0",
    },
    {
      name: "black",
      code: "#000000",
    },
    {
      name: "Grey",
      code: "#888888",
    },
    {
      name: "blue",
      code: "#000053",
    },
    {
      name: "green",
      code: "#0B780B",
    },
    {
      name: "red",
      code: "#FF0000",
    },
    {
      name: "gold",
      code: "#FFD700",
    },
    {
      name: "maroon",
      code: "#800000",
    },
    {
      name: "beige",
      code: "#F5F5DC",
    },
    {
      name: "pink",
      code: "#DA55AD",
    },
    {
      name: "brown",
      code: "#966938",
    },
    {
      name: "burgundy",
      code: "#6C1C1F",
    },
    {
      name: "yellow",
      code: "#FFFF00",
    },
    {
      name: "bronze",
      code: "#574327",
    },
    {
      name: "purple",
      code: "#57105C",
    },
    {
      name: "Turqouise",
      code: "#22EEE3",
    },
    {
      name: "orange",
      code: "#FE4F09",
    },
    {
      name: "indigo",
      code: "#3A125E",
    },
    {
      name: "magneta",
      code: "#65183A",
    },
  ];

  return (
    <>
      <div className="h-100 container-md px-0 ">
        <div className="row searchFilter_Main mx-3   mx-md-0 d-none d-md-flex ">
          {/* <div className="col-lg-2 col-md-3 col-4 px-0 pb-3 pb-md-0 searchBarFilter">
              <TextField
                id="filtercity"
                label="Search"
                variant="filled"
                placeholder="e.g. Alto 2019"
                InputLabelProps={{ shrink: true }}
                className="searchSideTabsInput"
                type="search"
                value={SearchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {SearchInput !== "" && (
                        <IconButton
                          onClick={handleSearchChange}
                          sx={{ padding: 0 }}
                        >
                          <SearchIcon />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            </div> */}

          <div className="col-lg-3 col-md-3 gap-5 col-4 px-2  pb-3 pb-md-0 ">
            <div className="dropdown  " style={{ position: "relative" }}>
              <Autocomplete
                id="filtercity"
                options={allCities || []}
                getOptionLabel={(option) => option?.cityName}
                value={selectedCityValue}
                onChange={handleAutocompleteCityChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="All Cities"
                    InputLabelProps={{ shrink: true }}
                    className="searchSideTabsInput   "
                  />
                )}
              />
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-4 px-2 pb-3 pb-md-0 ">
            <Autocomplete
              id="vehicleMake"
              className="searchBar_feilds"
              options={allMake || []}
              getOptionLabel={(option) => option?.bikemake_name}
              value={selectedMakeValue}
              onChange={handleAutocompleteMakeChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Car Make/Brand"
                  InputLabelProps={{ shrink: true }}
                  className="searchSideTabsInput"
                />
              )}
            />
          </div>

          <div className="col-lg-3 col-md-3 col-4 px-2 pb-3 pb-md-0 ">
            {allModel && allModel?.length > 0 ? (
              <Autocomplete
                id="vehicleMake"
                className="searchBar_feilds"
                options={allModel || []}
                getOptionLabel={(option) => option?.bikemodel_name}
                value={selectedModelValue}
                onChange={handleAutocompleteModelChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="searchSideTabsInput"
                    placeholder="Select Model"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            ) : (
              <Autocomplete
                id="vehicleMake"
                className="searchBar_feilds"
                options={allModel || []}
                getOptionLabel={(option) => option?.bikemodel_name}
                value={selectedModelValue}
                onChange={handleAutocompleteModelChange}
                disabled
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="searchSideTabsInput"
                    placeholder="Select Model"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            )}
          </div>

          <div className="col-lg-3 col-md-3 col-4 px-2 pb-3 pb-md-0 ">
            <Autocomplete
              id="vehicleMake"
              className="searchBar_feilds"
              options={modelYear || []}
              getOptionLabel={(option) => option?.year}
              value={selectedYearValue}
              onChange={handleAutocompleteYearChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Year"
                  InputLabelProps={{ shrink: true }}
                  className="searchSideTabsInput"
                />
              )}
            />
          </div>
        </div>

        <div className="row searchFilter_Main mx-3 mt-4 mx-md-0 d-none d-md-flex ">
          <div className="col-lg-4 col-md-3 gap-5 col-4 px-2  pb-3 pb-md-0 ">
            <div className="dropdown">
              <button
                className="btn  searchSideTabsInput border-1 border-success text-start color-black w-100 bg-white  searchDropdown btn-secondary dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Price Range
                <div className="toggle"></div>
              </button>
              <ul
                style={{ width: 400 }}
                className="dropdown-menu border-0 shadow-lg "
              >
                <div style={{ zIndex: 19999 }} className="p-4 ">
                  <h6 className="fw-bold color-secondary">Price Range (PKR)</h6>
                  <div className=" d-flex justify-content-center  align-content-center priceFilter">
                    <div className=" mx-3">
                      <label>Min Price:</label>
                      <div className="w-100">
                        <div className="  align-items-center mt-2">
                          <input
                            type="number"
                            value={selectedFilters.minPrice}
                            onChange={handleMinPriceChange}
                            min={0}
                            className="priceAmount"
                            max={selectedFilters.maxPrice}
                          />
                          <p className="mt-2 m-lg-1">
                            {formatPrice(selectedFilters.minPrice)}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mx-3 ">
                      <label>Max Price:</label>
                      <div className="w-100">
                        <div className=" align-items-center mt-2">
                          <input
                            type="number"
                            value={selectedFilters.maxPrice}
                            onChange={handleMaxPriceChange}
                            min={selectedFilters.minPrice}
                            max={100000000}
                            className="priceAmount"
                          />
                          <p className="mt-2 m-lg-1">
                            {formatPrice(selectedFilters.maxPrice)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-4 px-0 pb-3 pb-md-0 ">
            <div className="dropdown">
              <button
                className="btn  searchSideTabsInput border-1 border-success text-start color-black w-100 bg-white  searchDropdown btn-secondary dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                More filters
                <div className="toggle"></div>
              </button>
              <ul
                style={{ width: 400 }}
                className="dropdown-menu border-0 shadow-lg "
              >
                <div style={{ zIndex: 19999 }} className="p-4 ">
                  {/* <h6 className="fw-bold color-secondary">Ads</h6> */}
                  <div className="priceFilter">
                    <div className=" d-flex align-items-start mb-3">
                      <div className="">
                        <label>Featured Ads:</label>
                      </div>
                      <div className="w-50">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="featureAd"
                          checked={featureAd}
                          value={selectedFilters.minPrice}
                          onChange={handleFeatureAdChange}
                        />
                      </div>
                    </div>
                  </div>

                  <h6 className="fw-bold color-secondary mt-4 mb-3 ">
                    Category ( CC )
                  </h6>

                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    {vehicleCategory?.slice(0, more)?.map((category) => (
                      <button
                        onClick={() => handleCategorySelect(category)}
                        key={category?.categoryId}
                        className="rounded-4 px-3 py-1 moreFilter_btn me-2 mb-1"
                      >
                        {category?.category}cc
                      </button>
                    ))}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (more === 11) {
                          setMore(-1);
                        } else if (more === -1) {
                          setMore(11);
                        }
                      }}
                      style={{ fontSize: 14 }}
                      className="rounded-pill px-3 py-1 border-0 color-secondary fw-600 "
                    >
                      {more === 11 ? "Show More" : "Show Less"}
                    </button>
                  </div>

                  <h6 className="fw-bold color-secondary mt-4 mb-3 ">Colors</h6>

                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    {colorsData?.slice(0, moreColor)?.map((item) => (
                      <button
                        key={item?.name}
                        className="rounded-4 px-3 py-1 moreFilter_btn me-2 mb-1"
                      >
                        <div
                          className="rounded-circle"
                          style={{
                            backgroundColor: item.code,
                            width: "40px",
                            height: "40px",
                          }}
                        ></div>
                        {item.name}
                      </button>
                    ))}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (moreColor === 11) {
                          setMoreColor(-1);
                        } else if (moreColor === -1) {
                          setMoreColor(11);
                        }
                      }}
                      style={{ fontSize: 14 }}
                      className="rounded-pill px-3 py-1 border-0 color-secondary fw-600 "
                    >
                      {moreColor === 11 ? "Show More" : "Show Less"}
                    </button>
                  </div>

                  {/* {colorsData.map((value) => {
                    return (
                      <div
                        key={value.name}
                        className="d-flex align-items-center gap-2 flex-wrap"
                      >
                        <p>{value.name}</p>

                        <p>{value.code}</p>
                      </div>
                    );
                  })} */}
                </div>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 gap-5 col-4 px-2  pb-3 pb-md-0 ">
            {selectedMakes?.length !== 0 ||
            selectedCities?.length !== 0 ||
            selectedModels?.length !== 0 ||
            selectedYearValue !== null ||
            selectedCategoryValue !== null ||
            SearchInput !== "" ? (
              <Button
                variant="contained"
                onClick={handleClearAllFilters}
                sx={{
                  color: "#ffffff",
                  fontSize: 10,
                  padding: "5px 10px",
                }}
                className="rounded-lg  ClearButton w-100 h-100   bgSecondary d-flex"
              >
                Clear All{" "}
              </Button>
            ) : (
              <Button
                disabled
                variant="contained"
                onClick={handleClearAllFilters}
                sx={{
                  color: "#ffffff",
                  fontSize: 10,
                  padding: "5px 10px",
                }}
                className="rounded-lg  ClearButton w-100 h-100  text-white  bg-secondary d-flex"
              >
                Clear All{" "}
              </Button>
            )}
          </div>
        </div>

        {/* //mobile */}

        <div className="row mx-3 mt-4 d-md-none  ">
          <div className="col-12 px-0 pb-md-0 searchBarFilter">
            <TextField
              id="filtercity"
              // label="Search"
              variant="filled"
              placeholder="e.g. Alto 2019"
              InputLabelProps={{ shrink: true }}
              className="searchSideTabsInputMob w-100"
              type="search"
              value={SearchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleSearchChange}
                      sx={{ padding: 0 }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>

        <div className="p-3 d-md-none d-flex justify-content-evenly align-items-center mobileFilters overflow-x-scroll">
          <Button
            variant="text"
            className={`rounded-pill fw-500 border ${
              selectedCityValue ? "bgSecondary text-white" : "text-dark"
            }`}
            onClick={toggleDrawerCity}
            sx={{
              color: "#b80505b",
              width: "100%",
              minWidth: "unset",
              fontSize: "12px", // Adjust the font size as needed
              padding: "5px 10px", // Increase padding for a larger button
              borderRadius: "50px", // Rounded pill shape
              textTransform: "none", // Preserve the text casing
            }}
          >
            {selectedCityValue ? selectedCityValue?.cityName : "City"}
            <KeyboardArrowDownIcon
              color="inherit"
              sx={{ fontSize: 18, pl: 0.5 }}
            />
          </Button>

          <Button
            variant="text"
            className={`rounded-pill fw-500 border ${
              selectedMakeValue?.bikemake_name
                ? "bgSecondary text-white"
                : "text-dark"
            }`}
            onClick={toggleDrawerMake}
            sx={{
              color: "#b80505b",
              width: "100%",
              minWidth: "unset",
              fontSize: "12px", // Adjust the font size as needed
              ml: 1,
              padding: "5px 10px", // Increase padding for a larger button
              borderRadius: "50px", // Rounded pill shape
              textTransform: "none", // Preserve the text casing
            }}
          >
            {selectedMakeValue?.bikemake_name
              ? selectedMakeValue?.bikemake_name
              : "Make"}
            <KeyboardArrowDownIcon
              color="inherit"
              sx={{ fontSize: 18, pl: 0.5 }}
            />
          </Button>

          <Button
            variant="text"
            className={`rounded-pill fw-500 border ${
              selectedModelValue ? "bgSecondary text-white" : "text-dark"
            } ${selectedMakeValue ? "opacity-100" : "opacity-50"}`}
            onClick={toggleDrawerModel}
            sx={{
              color: "#b80505b",
              width: "100%",
              minWidth: "unset",
              fontSize: "12px", // Adjust the font size as needed
              ml: 1,
              padding: "5px 10px", // Increase padding for a larger button
              borderRadius: "50px", // Rounded pill shape
              textTransform: "none", // Preserve the text casing
            }}
          >
            {selectedModelValue ? selectedModelValue?.model_name : "Model"}
            <KeyboardArrowDownIcon
              color="inherit"
              sx={{ fontSize: 18, pl: 0.5 }}
            />
          </Button>

          <Button
            variant="text"
            className={`rounded-pill fw-500 border ${
              selectedYearValue ? "bgSecondary text-white" : "text-dark"
            }`}
            onClick={toggleDrawerYear}
            sx={{
              color: "#b80505b",
              width: "100%",
              minWidth: "unset",
              fontSize: "12px", // Adjust the font size as needed
              ml: 1,
              padding: "5px 10px", // Increase padding for a larger button
              borderRadius: "50px", // Rounded pill shape
              textTransform: "none", // Preserve the text casing
            }}
          >
            {selectedYearValue ? selectedYearValue?.year : "Year"}
            <KeyboardArrowDownIcon
              color="inherit"
              sx={{ fontSize: 18, pl: 0.5 }}
            />
          </Button>
        </div>

        <div className="d-flex column-gap-3">
          {selectedCities?.length > 0 ? (
            <Chip
              label={selectedCities[0]}
              variant="outlined"
              onDelete={ClearCityFilter}
              sx={{
                backgroundColor: "#ffffff42",
                color: "#212121",
                // border: "1px solid #b80505",
                marginTop: 2,
              }}
              className="clearChip shadow-lg "
            />
          ) : null}

          {selectedMakes?.length > 0 ? (
            <Chip
              label={selectedMakes[0]}
              variant="outlined"
              onDelete={ClearMakeFilter}
              sx={{
                backgroundColor: "#ffffff42",
                color: "#212121",
                // border: "1px solid #b80505",
                marginTop: 2,
              }}
              className="clearChip shadow-lg "
            />
          ) : null}

          {selectedModels?.length > 0 ? (
            <Chip
              label={selectedModels[0]}
              variant="outlined"
              onDelete={ClearModelFilter}
              sx={{
                backgroundColor: "#ffffff42",
                color: "#212121",
                // border: "1px solid #b80505",
                marginTop: 2,
              }}
              className="clearChip shadow-lg "
            />
          ) : null}

          {selectedYearValue !== null ? (
            <Chip
              label={selectedYearValue?.year}
              variant="outlined"
              onDelete={ClearYearFilter}
              sx={{
                backgroundColor: "#ffffff42",
                color: "#212121",
                // border: "1px solid #b80505",
                marginTop: 2,
              }}
              className="clearChip shadow-lg "
            />
          ) : null}
        </div>
        <Drawer
          anchor="bottom"
          open={openMake}
          onClose={toggleDrawerMake}
          PaperProps={{
            sx: {
              minHeight: "30%",
              maxHeight: "80%",
              height: "auto",
              // maxHeight: "75vh", // Adjust height as needed
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
              overflow: "auto",
              zIndex: 1000,
            },
          }}
        >
          <Box
            sx={{
              padding: 3,
              height: "100%",
              overflowY: "scroll",
            }}
          >
            <h4 className="text-dark fw-600 fs-6 mx-3 pb-2 border-bottom">
              Select Make
            </h4>

            {allMake?.length > 0 &&
              allMake?.map((make, index) => {
                return (
                  <Button
                    key={index}
                    onClick={() => {
                      handleAutocompleteMakeChange(index, make);
                      toggleDrawerMake();
                    }}
                    sx={{
                      fontSize: "12px", // Adjust the font size as needed
                      padding: "6px 10px", // Increase padding for a larger button
                      m: 1,
                      borderRadius: "50px", // Rounded pill shape
                      textTransform: "none", // Preserve the text casing
                    }}
                    className="text-black fw-light "
                    style={{ border: "1px solid #b8050580" }}
                  >
                    {make.bikemake_name}
                  </Button>
                );
              })}
          </Box>
        </Drawer>

        <Drawer
          anchor="bottom"
          open={openCity}
          onClose={toggleDrawerCity}
          PaperProps={{
            sx: {
              minHeight: "30%",
              maxHeight: "80%",
              height: "auto",
              // maxHeight: "75vh", // Adjust height as needed
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
              overflow: "auto",
              zIndex: 1000,
            },
          }}
        >
          <Box
            sx={{
              padding: 3,
              height: "100%",
              overflowY: "scroll",
            }}
          >
            <h4 className="text-dark fw-600 fs-6 mx-3 pb-2 border-bottom">
              Select City
            </h4>
            {allCities?.length > 0 &&
              allCities?.map((city, index) => {
                return (
                  <Button
                    key={index}
                    onClick={() => {
                      handleAutocompleteCityChange(index, city);
                      toggleDrawerCity();
                    }}
                    sx={{
                      color: "#b80505b",
                      fontSize: "12px", // Adjust the font size as needed
                      padding: "6px 10px", // Increase padding for a larger button
                      m: 1,
                      borderRadius: "50px", // Rounded pill shape
                      textTransform: "none", // Preserve the text casing
                    }}
                    className="text-black fw-light "
                    style={{ border: "1px solid #b8050580" }}
                  >
                    {city.cityName}
                  </Button>
                );
              })}
          </Box>
        </Drawer>

        <Drawer
          anchor="bottom"
          open={openModel}
          onClose={toggleDrawerModel}
          PaperProps={{
            sx: {
              minHeight: "30%",
              maxHeight: "80%",
              height: "auto",
              // maxHeight: "75vh", // Adjust height as needed
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
              overflow: "auto",
              zIndex: 1000,
            },
          }}
        >
          <Box
            sx={{
              padding: 3,
              height: "100%",
              overflowY: "scroll",
            }}
          >
            <h4 className="text-dark fw-600 fs-6 mx-3 pb-2 border-bottom">
              Select Model
            </h4>

            {allModel?.length > 0 &&
              allModel?.map((model, index) => {
                return (
                  <Button
                    key={index}
                    onClick={() => {
                      handleAutocompleteModelChange(index, model);
                      toggleDrawerModel();
                    }}
                    sx={{
                      color: "#b80505b",
                      fontSize: "12px", // Adjust the font size as needed
                      padding: "6px 10px", // Increase padding for a larger button
                      borderRadius: "50px", // Rounded pill shape
                      textTransform: "none", // Preserve the text casing
                      m: 1,
                    }}
                    className="text-black fw-light "
                    style={{ border: "1px solid #b8050580" }}
                  >
                    {model.model_name}
                  </Button>
                );
              })}
          </Box>
        </Drawer>

        <Drawer
          anchor="bottom"
          open={openYear}
          onClose={toggleDrawerYear}
          PaperProps={{
            sx: {
              minHeight: "30%",
              maxHeight: "80%",
              height: "auto",
              // maxHeight: "75vh", // Adjust height as needed
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
              overflow: "auto",
              zIndex: 1000,
            },
          }}
        >
          <Box
            sx={{
              padding: 3,
              height: "100%",
              overflowY: "scroll",
            }}
          >
            <h4 className="text-dark fw-600 fs-6 mx-3 pb-2 border-bottom">
              Select Year
            </h4>

            {modelYear?.length > 0 &&
              modelYear?.map((year, index) => {
                return (
                  <Button
                    key={index}
                    onClick={() => {
                      handleAutocompleteYearChange(index, year);
                      toggleDrawerYear();
                    }}
                    sx={{
                      color: "#b80505b",
                      fontSize: "12px", // Adjust the font size as needed
                      padding: "6px 10px", // Increase padding for a larger button
                      m: 1,
                      borderRadius: "50px", // Rounded pill shape
                      textTransform: "none", // Preserve the text casing
                    }}
                    className="text-black fw-light "
                    style={{ border: "1px solid #b8050580" }}
                  >
                    {year.year}
                  </Button>
                );
              })}
          </Box>
        </Drawer>
      </div>

      <style jsx>{`
        h2.font-bold.text-gray-800 {
          font-size: 26px;
          margin-top: 22px;
        }

        .showMoreBtn {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .flex.flex-wrap.items-center.gap-x-10.gap-y-4 {
          display: flex;
          justify-content: space-between;
        }
        .cityCount {
          color: grey;
        }
      `}</style>
    </>
  );
}
